import { createReducer } from 'redux-act';
import actions from '../actions/mrfInterviewAction';

const initialState = {
  assignedInterviewPending: false,
  assignedInterviewRes: null,
  assignedInterviewError: null,

  getAssignedInterviewPending: false,
  getAssignedInterviewRes: null,
  getAssignedInterviewError: null,

  getInterviewrPending: false,
  getInterviewrRes: null,
  getInterviewrError: null,

  getQuestionByInterviewStagePending: false,
  getQuestionByInterviewStageRes: null,
  getQuestionByInterviewStageError: null,

  fillFeedbackFormPending: false,
  fillFeedbackFormRes: null,
  fillFeedbackFormError: null,

  getInterviewDetailsByIdPending: false,
  getInterviewDetailsByIdRes: null,
  getInterviewDetailsByIdError: null,

};
/* Assigned Interview Reducers */
const handleAssignedInterviewRequest = state1 => {
  return {
    ...state1,
    ...{
      assignedInterviewPending: true,
      assignedInterviewRes: null,
      assignedInterviewError: null,
    },
  };
};
const handleAssignedInterviewSuccess = (state1, payload) => {
  return {
    ...state1,
    ...{
      assignedInterviewPending: false,
      assignedInterviewRes: payload,
      assignedInterviewError: null,
    },
  };
};
const handleAssignedInterviewError = (state1, payload) => ({
  ...state1,
  ...{
    assignedInterviewPending: false,
    assignedInterviewRes: null,
    assignedInterviewError: payload,
  },
});


/* Get Assigned Interview Reducers */
const handleGetAssignedInterviewRequest = state1 => {
  return {
    ...state1,
    ...{
      getAssignedInterviewPending: true,
      getAssignedInterviewRes: null,
      getAssignedInterviewError: null,
    },
  };
};
const handleGetAssignedInterviewSuccess = (state1, payload) => {
  return {
    ...state1,
    ...{
      getAssignedInterviewPending: false,
      getAssignedInterviewRes: payload,
      getAssignedInterviewError: null,
    },
  };
};
const handleGetAssignedInterviewError = (state1, payload) => ({
  ...state1,
  ...{
    getAssignedInterviewPending: false,
    getAssignedInterviewRes: null,
    getAssignedInterviewError: payload,
  },
});

/* Get interviewr Reducer */
const handleGetInterviewrRequest = state1 => {
  return {
    ...state1,
    ...{
      getInterviewrPending: true,
      getInterviewrRes: null,
      getInterviewrError: null,
    },
  };
};
const handleGetInterviewrSuccess = (state1, payload) => {
  return {
    ...state1,
    ...{
      getInterviewrPending: false,
      getInterviewrRes: payload,
      getInterviewrError: null,
    },
  };
};
const handleGetInterviewrError = (state1, payload) => ({
  ...state1,
  ...{
    getInterviewrPending: false,
    getInterviewrRes: null,
    getInterviewrError: payload,
  },
});

/* Get Question By Interview Stage Reducer*/
const handleGetQuestionByInterviewStageRequest = state1 => {
  return {
    ...state1,
    ...{
      getQuestionByInterviewStagePending: true,
      getQuestionByInterviewStageRes: null,
      getQuestionByInterviewStageError: null,
    },
  };
};
const handleGetQuestionByInterviewStageSuccess = (state1, payload) => {
  return {
    ...state1,
    ...{
      getQuestionByInterviewStagePending: false,
      getQuestionByInterviewStageRes: payload,
      getQuestionByInterviewStageError: null,
    },
  };
};
const handleGetQuestionByInterviewStageError = (state1, payload) => ({
  ...state1,
  ...{
    getQuestionByInterviewStagePending: false,
    getQuestionByInterviewStageRes: null,
    getQuestionByInterviewStageError: payload,
  },
});


/* Fill Feedback Form Reducer*/
const handleFillFeedbackFormRequest = state1 => {
  return {
    ...state1,
    ...{
      fillFeedbackFormPending: true,
      fillFeedbackFormRes: null,
      fillFeedbackFormError: null,
    },
  };
};
const handleFillFeedbackFormSuccess = (state1, payload) => {
  return {
    ...state1,
    ...{
      fillFeedbackFormPending: false,
      fillFeedbackFormRes: payload,
      fillFeedbackFormError: null,
    },
  };
};
const handleFillFeedbackFormError = (state1, payload) => ({
  ...state1,
  ...{
    fillFeedbackFormPending: false,
    fillFeedbackFormRes: null,
    fillFeedbackFormError: payload,
  },
});

/* Get Interview Details By Id Reducer */
const handleGetInterviewDetailsByIdRequest = state1 => {
  return {
    ...state1,
    ...{
      getInterviewDetailsByIdPending: true,
      getInterviewDetailsByIdRes: null,
      getInterviewDetailsByIdError: null,
    },
  };
};
const handleGetInterviewDetailsByIdSuccess = (state1, payload) => {
  return {
    ...state1,
    ...{
      getInterviewDetailsByIdPending: false,
      getInterviewDetailsByIdRes: payload,
      getInterviewDetailsByIdError: null,
    },
  };
};
const handleGetInterviewDetailsByIdError = (state1, payload) => ({
  ...state1,
  ...{
    getInterviewDetailsByIdPending: false,
    getInterviewDetailsByIdRes: null,
    getInterviewDetailsByIdError: payload,
  },
});

// Clear Mrf Interview Store Reducer */
const handelClearMrfInterviewStore = (state, payload) => {
  switch (payload) {
    case 'HANDLE_CLEAR_ASSIGNED_INTERVIEW_STORE':
      return {
        ...state,
        ...{
          assignedInterviewPending: false,
          assignedInterviewRes: null,
          assignedInterviewError: null,
        },
      };
    case 'HANDLE_CLEAR_GET_ASSIGNED_INTERVIEW_STORE':
      return {
        ...state,
        ...{
          getAssignedInterviewPending: false,
          getAssignedInterviewRes: null,
          getAssignedInterviewError: null,
        },
      };
      case 'HANDLE_CLEAR_GET_INTERVIEWR_STORE':
      return {
        ...state,
        ...{
          getInterviewrPending: false,
          getInterviewrRes: null,
          getInterviewrError: null,
        
        },
      };
    case 'HANDLE_CLEAR_GET_QUESTION_BY_INTERVIEW_STAGE_STORE':
      return {
        ...state,
        ...{
          getQuestionByInterviewStagePending: false,
          getQuestionByInterviewStageRes: null,
          getQuestionByInterviewStageError: null,
        },
      };
    case 'HANDLE_CLEAR_FILL_FEEDBACK_FORM_STORE':
      return {
        ...state,
        ...{
          fillFeedbackFormPending: false,
          fillFeedbackFormRes: null,
          fillFeedbackFormError: null,
        },
      };
     
    default:
      return state;
  }
};



export default createReducer(
  {
    [actions.assignedInterviewRequest]: handleAssignedInterviewRequest,
    [actions.assignedInterviewSuccess]: handleAssignedInterviewSuccess,
    [actions.assignedInterviewError]: handleAssignedInterviewError,

    [actions.getAssignedInterviewRequest]: handleGetAssignedInterviewRequest,
    [actions.getAssignedInterviewSuccess]: handleGetAssignedInterviewSuccess,
    [actions.getAssignedInterviewError]: handleGetAssignedInterviewError,

    [actions.getInterviewrRequest]: handleGetInterviewrRequest,
    [actions.getInterviewrSuccess]: handleGetInterviewrSuccess,
    [actions.getInterviewrError]: handleGetInterviewrError,

    [actions.getQuestionByInterviewStageRequest]: handleGetQuestionByInterviewStageRequest,
    [actions.getQuestionByInterviewStageSuccess]: handleGetQuestionByInterviewStageSuccess,
    [actions.getQuestionByInterviewStageError]: handleGetQuestionByInterviewStageError,

    [actions.fillFeedbackFormRequest]: handleFillFeedbackFormRequest,
    [actions.fillFeedbackFormSuccess]: handleFillFeedbackFormSuccess,
    [actions.fillFeedbackFormError]: handleFillFeedbackFormError,

    [actions.getInterviewDetailsByIdRequest]: handleGetInterviewDetailsByIdRequest,
    [actions.getInterviewDetailsByIdSuccess]: handleGetInterviewDetailsByIdSuccess,
    [actions.getInterviewDetailsByIdError]: handleGetInterviewDetailsByIdError,

    [actions.handelClearMrfInterviewStore]: handelClearMrfInterviewStore,

  },
  initialState,
);